import { useMutation, useQueryClient } from "@tanstack/react-query";
import { cmsClient } from "src/services/cmsClient";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";

const updateObservationCategory = async ({
	name,
	categoryId,
	audienceGroupIds
}: {
	name: string;
	categoryId: number;
	audienceGroupIds?: number[];
}) => {
	// PATCH semantics: only include `audience_group_ids` when the caller
	// explicitly provided it. Omitting the key leaves the audience unchanged on
	// the server; sending an empty array clears it. This matches the backend
	// contract documented in PatchCategoryAsync.
	const url = `/observations/admin/forms/categories/${categoryId}/`;
	const payload: { name: string; audience_group_ids?: number[] } = { name };
	if (audienceGroupIds !== undefined) {
		payload.audience_group_ids = audienceGroupIds;
	}
	const response = await cmsClient.patch(url, payload);

	return response.data;
};

const useUpdateObservationCategory = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		queryClient.invalidateQueries(["observation-categories"]);

		toast.success(
			<CustomToast type="Success" message="Category updated successfully" />,
			{ hideProgressBar: true }
		);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation({
		mutationFn: updateObservationCategory,
		onSuccess,
		onError
	});

	return mutation;
};

export default useUpdateObservationCategory;
